window.o_util = window.o_util || {};

/**
 * Sheet handler class. This class provides function to interact with the currently active sheet.
 */
window.o_global.pali.sheet = (function () {
  const settingsMap = {
    title: "data-sheet-title",
    headerContent: "data-sheet-header-content",
    content: "data-sheet-content",
    url: "data-sheet-url",
    base64url: "data-sheet-ub64e",
    menuContent: "data-sheet-menu-content",
    openCallback: "data-sheet-open-callback",
    closeCallback: "data-sheet-close-callback",
    trackingObject: "data-sheet-tracking-object",
    showBackButton: "data-sheet-show-back-button",
    showCloseButton: "data-sheet-show-close-button",
    initialMobileHeight: "data-sheet-initial-mobile-height",
    lockMobileHeight: "data-sheet-lock-mobile-height",
    fullBleedContent: "data-sheet-full-bleed-content",
    contentGreyBackground: "data-sheet-content-grey-background",
    convertLayerLinks: "data-sheet-convert-layer-links",
  };
  let activeSheet; // Active Sheet instance.

  function getScrollbarWidth() {
    // Creating invisible container
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll"; // forcing scrollbar to appear
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
    document.getElementsByTagName("body")[0].appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement("div");
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
  }

  /**
   * Prevent the scrolling event.
   *
   * @private
   */
  function preventScroll() {
    const scrollPosition = {
      x: document.documentElement.scrollLeft || document.getElementsByTagName("body")[0].scrollLeft,
      y: document.documentElement.scrollTop || document.getElementsByTagName("body")[0].scrollTop,
    };

    window.scrollTo(scrollPosition.x, scrollPosition.y);
  }

  /** href
   * Enable scroll prevention.
   *
   * @private
   */
  function enableScrollPrevention() {
    document.documentElement.style.overflow = "hidden";

    if (!window.o_global.breakpoint.isSmall()) {
      document.documentElement.style.marginRight = `${getScrollbarWidth()}px`;
    }

    window.addEventListener("scroll", preventScroll);
  }

  /**
   * Disable scroll prevention.
   *
   * @private
   */
  function disableScrollPrevention() {
    document.documentElement.style.removeProperty("overflow");

    if (!window.o_global.breakpoint.isSmall()) {
      document.documentElement.style.removeProperty("margin-right");
    }

    window.removeEventListener("scroll", preventScroll);
  }

  /**
   * Registers active sheet instance.
   *
   * @param {Object} [sheet]    Active sheet.
   */
  function setActiveSheet(sheet) {
    if (sheet) {
      if (activeSheet !== undefined) {
        activeSheet.close();
      }

      activeSheet = sheet;
      enableScrollPrevention();
    } else {
      activeSheet = undefined;
      disableScrollPrevention();
    }
  }

  window.o_global.eventQBus.on("assets.sheet.activeSheetChanged", (e) => {
    setActiveSheet(e);
  });

  /**
   * Parse the data attributes of the trigger to customize the Sheet.
   *
   * @private
   *
   * @param {Object} element      Element with data attributes.
   *
   * @return {Array} Settings for new Sheet.
   */
  function parseDataAttributes(element) {
    const settings = [];

    Object.keys(settingsMap).forEach((key) => {
      const attribute = element.getAttribute(settingsMap[key]);

      if (attribute) {
        let parsedAttribute = null;

        // Change strings to data-types.
        switch (attribute) {
          case "false":
            parsedAttribute = false;
            break;
          case "true":
            parsedAttribute = true;
            break;
          case "null":
            parsedAttribute = null;
            break;
          default:
            parsedAttribute = attribute;
        }

        if (key === "statusCallbacks") {
          try {
            parsedAttribute = JSON.parse(attribute);
          } catch (e) {
            throw new Error("Could not parse data-sheet-status-callbacks. Not valid json");
          }

          Object.keys(parsedAttribute).forEach((statusCode) => {
            parsedAttribute[statusCode] = window.o_util.core.convertStringToFunction(
              parsedAttribute[statusCode],
              window
            );
          });
        } else if (key.indexOf("Callback") > -1) {
          /* parsedAttribute = o_util.core.convertStringToFunction(
              attribute,
              window
            ); */

          // eslint-disable-next-line no-new-func
          const func = new Function(`return ${attribute}`)();
          parsedAttribute = func;
        }

        settings[key] = parsedAttribute;
      }
    });

    return settings;
  }

  /**
   * Initialize the sheet.
   *
   * @private
   *
   * @param {Object} event Event object
   */
  function initSheet(event) {
    let trigger = event.target;
    const isValidTrigger = window.o_util.misc.isValidMouseButton(event, 1);

    if (!trigger.classList.contains("js_openInPaliSheet")) {
      trigger = window.o_util.dom.getParentByClassName(trigger, "js_openInPaliSheet");
    }

    if (!!trigger && !!isValidTrigger) {
      const attributes = parseDataAttributes(trigger);

      if (attributes.base64url) {
        attributes.url = window.atob(attributes.base64url);
      }

      if (attributes.altUrl) {
        attributes.url = attributes.altUrl;

        // don't open Sheet if CMD (OSX) or CTRL (Windows) is pressed
        if (isValidTrigger && (event.metaKey || event.ctrlKey)) {
          return;
        }
      }

      if (window.o_util.dom.hasClassInParents(trigger, "pl_sheet")) {
        // Content switch.
        activeSheet.switchSheetContent(attributes);
      } else {
        // New sheet.
        const sheet = new window.o_global.pali.sheetBuilder(attributes);
        sheet.open();
      }

      window.o_util.event.stop(event);
    }
  }

  /**
   * Register click events for the sheet.
   */
  function init() {
    // Execute initialization a while after document ready.
    window.o_global.eventLoader.onReady(40, function () {
      window.o_util.event.delegate(document, "click", ".js_openInPaliSheet", function (event) {
        initSheet(event);
      });
    });
  }

  /**
   * Returns active sheet instance.
   *
   * @return {Object|undefined} Active Sheet instance.
   */
  function getActiveSheet() {
    if (activeSheet) {
      return activeSheet.exposeInterface();
    }
    return undefined;
  }

  return {
    init,
    getActiveSheet,
  };
})();

window.o_global.pali.sheet.init();
